import { sizes, ringRafterLayers } from "../../../constants/sizes";
import { useState, useRef } from "react";
import { ReactComponent as RingsIcon } from "../../../svgs/Rings.svg";
import { ReactComponent as DomeIcon } from "../../../svgs/dome.svg";

import { useReactToPrint } from "react-to-print";

const Rings = ({ project, handleEditProject }) => {
  const [layerManual, setLayerManual] = useState(false);
  const {
    kitName,
    size,
    rafterSize,
    ringLayers,
    skylightTint,
    skylightType,
    opener,
  } = project;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="sheet-comp-container">
      <div className="sheet-input">
        <div id="sheet-print-button" onClick={handlePrint}>
          print
        </div>

        <div className="sheet-input-item">
          <label>Rafter Size</label>
          <select
            className="form-control"
            name="rafterSize"
            onChange={(e) => handleEditProject(e)}
            defaultValue={rafterSize}
          >
            <option>2 x 12</option>
            <option>2 x 10</option>
            <option>LVL 1 1/2" x 11 3/4"</option>
            <option>LVL 1 3/4" x 11 7/8"</option>
            <option>LVL 1 3/4" x 14"</option>
          </select>
        </div>
        <div className="sheet-input-item">
          <label>Ring Layers</label>
          <div className="sheet-input-toggle-container">
            {(!layerManual && (
              <div
                className="sheet-manual-button"
                onClick={() => setLayerManual(true)}
              >
                set manually
              </div>
            )) || (
              <>
                <div
                  className="sheet-manual-button"
                  onClick={() => setLayerManual(false)}
                >
                  calculate
                </div>
                <input
                  className="form-control"
                  name="ringLayers"
                  onChange={(e) => handleEditProject(e)}
                  defaultValue={ringLayers}
                />
              </>
            )}
          </div>
        </div>
        <div className="sheet-input-section">
          <DomeIcon />
          <div className="sheet-input-item">
            <label>Tint</label>
            <select
              className="form-control"
              name="skylightTint"
              onChange={(e) => handleEditProject(e)}
              defaultValue={skylightTint}
            >
              <option>Clear Low-E</option>
              <option>Bronze Tint</option>
            </select>
          </div>
          <div className="sheet-input-item">
            <label>Type</label>
            <select
              className="form-control"
              name="skylightType"
              onChange={(e) => handleEditProject(e)}
              defaultValue={skylightType}
            >
              <option>Double</option>
              <option>Triple</option>
            </select>
          </div>

          <div className="sheet-input-item">
            <label>Opener</label>
            <select
              className="form-control"
              name="opener"
              onChange={(e) => handleEditProject(e)}
              defaultValue={opener}
            >
              <option>Manual</option>
              <option>Electric</option>
            </select>
          </div>
        </div>
      </div>
      <div className="sheet-output" ref={componentRef}>
        <div className="sheet-title">
          <div className="sheet-icon-title">
            <RingsIcon />
            <div>Rings</div>
          </div>
          <div>
            {kitName} - {sizes[size]}
          </div>
        </div>
        <div className="sheet-body">
          <div className="sheet-column">
            <div className="sheet-item">
              <div>Ring Size</div>
              <div>{size < 32 ? 5 : 6} ft</div>
            </div>
            <div className="sheet-item">
              <div>Rafter Size</div>
              <div>{rafterSize}</div>
            </div>
            <div className="sheet-item">
              <div>Ring Layers</div>
              <div>
                {layerManual ? ringLayers : ringRafterLayers[rafterSize]}
              </div>
            </div>
          </div>
          <div className="sheet-column">
            <div className="sheet-table--sm">
              <div className="sheet-table-title">
                <div>Skylight</div>
                <DomeIcon />
              </div>
              <div className="sheet-table-body">
                <div className="sheet-table-col">
                  <div>Size</div>
                  <div>Tint</div>
                  <div>type</div>
                  <div>opener</div>
                </div>
                <div className="sheet-table-col">
                  <div>{size < 32 ? 5 : 6} ft</div>
                  <div>{skylightTint}</div>
                  <div>{skylightType}</div>
                  <div>{opener}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="sheet-body">
          <div className="sheet-table--sm">
            <div className="sheet-table-body">
              <div className="sheet-table-col">
                <div>hardware package [on pallet]</div>
                <div>hardware package [photo taken]</div>
                <div>full pallet [photo taken]</div>
              </div>
              <div className="sheet-table-col">
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rings;
